module.exports = __webpack_public_path__ + "static/media/counterBack.e3da054f.svg";